<ol class="breadcrumb mt-4 mb-0">
	@for (breadcrumb of breadcrumbs; track breadcrumb) {
		<li class="breadcrumb-item" [ngClass]="{ active: breadcrumb.active }">
			@if (breadcrumb.link) {
				<a [routerLink]="breadcrumb.link">{{ breadcrumb.text }}</a>
			}
			@if (!breadcrumb.link) {
				<span>{{ breadcrumb.text }}</span>
			}
		</li>
	}
</ol>
